/* @flow */
import type { Node } from 'react';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import type { TApartData } from '../../types/apart';
import type { TRootState } from '../../types/rootState';
import {
	Content,
	ContentChips,
	ContentText,
	LivingBanner,
	LivingBannerButton,
	LivingBannerContent,
	LivingBannerImage,
	LivingBannerList,
	LivingBannerText,
	LivingBannerTitle,
	LoaderWrapper,
	ModalTitle,
	NoPhone,
	Phone,
	PhonesWrapper,
	Root,
} from './styles';
import { PhoneIcon } from '../Icons';
import type { TLiraPopupsState } from '../../reducers/liraPopups';
import { getTextsFromDatabase } from '../../actions/lira';
import type { TDispatch } from '../../types/core';
import { AppContext } from '../AppContext';
import CallbackIcons from '../CallbackIcons';
import { Illustration } from './images';
import Button from '../Button2.0';
import Loader from '../Loader';
import { LIRA_SET_CALLBACK_POPUP_TEXTS } from '../../constants';

type TProps = {
	handlerModalToggle: () => {},
};

const ModalCallbackDeveloper = ({ handlerModalToggle }: TProps): Node => {
	const dispatch: TDispatch = useDispatch();
	const store = useStore();
	const context = useContext(AppContext);

	const apartData: TApartData = useSelector((state: TRootState) => state.apartment.apartData);
	const liraPopups: TLiraPopupsState = useSelector((state: TRootState) => state.liraPopups);

	const {
		complex: {
			developer: { name },
		},
		developerPhoneNumbers,
	} = apartData;
	const { popupCallbackTexts } = liraPopups;

	useEffect(() => {
		if (!popupCallbackTexts) {
			getTextsFromDatabase(
				'site_popup_direct_cta',
				['promo_block_text', 'promo_block_list', 'ad_text'],
				LIRA_SET_CALLBACK_POPUP_TEXTS,
			)(dispatch, store.getState, context);
		}
	}, []);

	if (popupCallbackTexts) {
		return (
			<Root>
				<ModalTitle>Связаться с застройщиком &laquo;{name}&raquo;</ModalTitle>
				{developerPhoneNumbers?.length > 0 && developerPhoneNumbers[0].length > 0 ? (
					<>
						<Content>
							<ContentText>Позвоните застройщику и узнайте про</ContentText>
							<ContentChips>
								<li>Скидки и акции</li>
								<li>Ипотечные программы</li>
								<li>Отделку и цены</li>
								<li>Варианты дешевле</li>
							</ContentChips>
						</Content>
						<PhonesWrapper>
							{developerPhoneNumbers.map((item) => (
								<Phone key={item} href={`tel:+7${item}`}>
									<svg>{PhoneIcon}</svg>
									{item.replace(/^(\d{3})(\d{3})(\d{2})(\d{2})$/, '+7 ($1) $2 $3$4')}
								</Phone>
							))}
						</PhonesWrapper>
					</>
				) : (
					<PhonesWrapper>
						<NoPhone>Телефон не предоставлен</NoPhone>
					</PhonesWrapper>
				)}
				<LivingBanner>
					<LivingBannerContent>
						{popupCallbackTexts?.promoBlockText?.title && (
							<LivingBannerTitle>{popupCallbackTexts.promoBlockText.title}</LivingBannerTitle>
						)}
						{popupCallbackTexts?.promoBlockText?.text && (
							<LivingBannerText>{popupCallbackTexts.promoBlockText.text}</LivingBannerText>
						)}
						{popupCallbackTexts?.promoBlockList?.text?.length > 0 && (
							<LivingBannerList>
								{popupCallbackTexts.promoBlockList.text.map((item) => (
									<li key={Math.random()}>{item}</li>
								))}
							</LivingBannerList>
						)}
						<LivingBannerButton>
							<Button
								id="buttonCallback"
								style={{ padding: '2px 18px', height: '44px', borderColor: 'currentColor' }}
								onClick={() => handlerModalToggle('innerCallback')}
								color="white"
								design="rounded"
								size="xs"
							>
								Обратиться к специалисту
							</Button>
						</LivingBannerButton>
						<CallbackIcons />
					</LivingBannerContent>
					<LivingBannerImage>
						<svg fill="none" viewBox="0 0 211 258">
							{Illustration}
						</svg>
					</LivingBannerImage>
				</LivingBanner>
			</Root>
		);
	}

	return (
		<LoaderWrapper>
			<Loader />
		</LoaderWrapper>
	);
};

export default ModalCallbackDeveloper;
